/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { ID } from '@gh/common-shared-data';
import { NotificationService, WaitingService } from '@gh/core-ui';
import { openInNewWindow } from '@gh/core-util';
import { PurchaseOrderStatus } from '@gh/supplier-shared-data';
import { isNil } from 'lodash';
import { PurchaseOrdersModel, SupplierPurchaseOrderListBusinessService } from '../../resources';

@Component({
  selector: 'gh-purchase-orders',
  templateUrl: 'supplier-purchase-order-list.component.html',
  styleUrls: ['./supplier-purchase-order-list.component.scss'],
})
export class SupplierPurchaseOrderListComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  dataSource: InfiniteMatDataSource<PurchaseOrdersModel>;
  displayedColumns: string[] = ['deliveryDate', 'status', 'officeName', 'purchaseOrder', 'jobOrderId'];
  showRejected: boolean = true;

  constructor(
    private businessService: SupplierPurchaseOrderListBusinessService,
    private notifications: NotificationService,
    private waitings: WaitingService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToNavigation();
  }

  getOrderId(index: number, order: PurchaseOrdersModel): ID {
    return order.jobOrderId;
  }

  getRowClass(order: PurchaseOrdersModel): string {
    return (order.statusValue || '').toLowerCase();
  }

  isOrderPending(order: PurchaseOrdersModel): boolean {
    return PurchaseOrderStatus.Pending === order.statusValue && !isNil(order.deliveryDate);
  }

  toggleRejected(change: MatSlideToggleChange): void {
    this.showRejected = change.checked;
    this.loadOrders();
  }

  reject(order: PurchaseOrdersModel): void {
    this.businessService
      .reject(order.jobOrderId, order.version!).pipe(// tslint:disable-line:no-non-null-assertion
      this.waitings.operator())
      .subscribe(
        () => this.dataSource.fire(),
        () => this.notifications.error('msg_order_changes'),
      );
  }

  accept(order: PurchaseOrdersModel): void {
    this.businessService
      .accept(order.jobOrderId, order.version!).pipe(// tslint:disable-line:no-non-null-assertion
      this.waitings.operator())
      .subscribe(
        () => this.dataSource.fire(),
        () => this.notifications.error('msg_order_changes'),
      );
  }

  view(order: PurchaseOrdersModel): void {
    openInNewWindow(order.fileUrl);
  }

  private loadOrders(): void {
    const { officeId } = this.route.snapshot.params;
    this.dataSource = InfiniteMatDataSource.wrap(this.businessService.findAll(
      this.showRejected,
      officeId === 'all' ? void 0 : officeId));
    this.dataSource.sort = this.sort;
  }

  private subscribeToNavigation(): void {
    this.route
      .params
      .subscribe(() => this.loadOrders());
  }
}
